import clsx from 'clsx';
import { IconButton } from '../../components/IconButton';
import {
  Fullscreen,
  FullscreenExit,
  Menu,
  PictureInPicture,
  SettingsRemote,
} from '@material-ui/icons';
import { useState } from 'react';
import { ActionsMenu } from './ActionsMenu';
import { useCitrusView } from '../../contexts/CitrusViewContext';

interface Props {
  fullscreen: boolean;
  hovering: boolean;
  onUnHideRemote(): void;
  setFullscreen(fullscreen: boolean): void;
}

export const VideoToolbarTop = ({
  fullscreen,
  hovering,
  onUnHideRemote,
  setFullscreen,
}: Props) => {
  const { hideRemote, isMobile, playerEl, remote, source } = useCitrusView();
  const [actionMenuOpen, setActionMenuOpen] = useState(false);
  const classes = useStyles();

  if (isMobile || source === undefined) return null;

  const renderFullScreenButtons = () => {
    if (isMobile) return null;
    if (fullscreen)
      return (
        <IconButton
          className={classes.iconButton}
          onClick={() => {
            if (document.exitFullscreen) {
              document.exitFullscreen().then(() => setFullscreen(false));
              //@ts-ignore
            } else if (document.webkitExitFullscreen) {
              //@ts-ignore
              document.webkitExitFullscreen();
            }
            setFullscreen(false);
          }}
        >
          <FullscreenExit />
        </IconButton>
      );

    return (
      <IconButton
        className={classes.iconButton}
        onClick={() => setFullscreen(true)}
      >
        <Fullscreen />
      </IconButton>
    );
  };

  return (
    <>
      <div
        className={clsx(
          'transition-all duration-300 absolute z-10 inline-flex items-start justify-between w-full p-2 pointer-events-none',
          {
            'scale-100 opacity-100': hovering,
            'scale-125 opacity-0': !hovering,
          }
        )}
      >
        {isMobile === false ? (
          <IconButton
            className={clsx(
              'z-20 pointer-events-none children:pointer-events-auto',
              {
                ['hidden']: actionMenuOpen,
                ['block']: actionMenuOpen === false,
              }
            )}
            onClick={(event: any) => {
              event.preventDefault();
              event.stopPropagation();
              setActionMenuOpen(true);
            }}
            type="button"
          >
            <Menu />
          </IconButton>
        ) : null}
        <div className="flex flex-col items-end ml-auto pointer-events-none">
          {renderFullScreenButtons()}
          <IconButton
            disabled={!Boolean(playerEl)}
            className={classes.iconButton}
            onClick={() => {
              if (playerEl)
                playerEl
                  .requestPictureInPicture()
                  .then()
                  .catch((err) => console.log(err));
            }}
          >
            <PictureInPicture />
          </IconButton>
          {remote && remote.hidden ? (
            <IconButton
              className={classes.iconButton}
              onClick={() => {
                hideRemote(false);
                onUnHideRemote();
              }}
            >
              <SettingsRemote />
            </IconButton>
          ) : null}
        </div>
      </div>
      <ActionsMenu
        open={actionMenuOpen}
        onClose={() => setActionMenuOpen(false)}
      />
    </>
  );
};

const useStyles = () => ({
  iconButton: 'z-10 pointer-events-auto',
});
